/***********************
 * CHART OPTIONS
 ************************/
// COLORS
const activity = "#00a0d6"
// XAXIS
const basicXaxis = {
  type: "datetime",
  labels: {
    datetimeUTC: false,
  },
}
const dayTimeXaxis = {
  type: "datetime",
  labels: {
    format: "d.M.",
    datetimeUTC: false,
  },
  tickPlacement: "on",
}
// YAXIS

// TOOLTIP
const tooltipXFormat = {
  show: false,
  format: "HH:mm",
}
const tooltipXFormatHistory = {
  format: "dd.MM.yyyy",
}

// TOOLS
const basicTools = {
  download: true,
  selection: true,
  zoom: true,
  zoomin: true,
  zoomout: true,
  pan: true,
  reset: true,
  customIcons: [],
}
const historyTools = {
  download: true,
  selection: false,
  zoom: false,
  zoomin: false,
  zoomout: false,
  pan: false,
  reset: false,
  customIcons: [],
}

// GRID
const basicGrid = {
  borderColor: "#f1f1f1",
}

// STROKE
const barStroke = { curve: "smooth" }
const areaStroke = {
  width: [2],
  curve: "smooth",
}
const lineStroke = {
  width: [3],
  curve: "smooth",
}
const columnStroke = {
  show: true,
  width: 2,
  colors: ["transparent"],
}

// FILL
const fillGradient = {
  type: "gradient",
  gradient: {
    shadeIntensity: 1,
    opacityFrom: 0.7,
    opacityTo: 0.9,
    stops: [0, 90, 100],
  },
}

// COLUMN
// plotOptions
const columnPlotOptions = {
  bar: {
    horizontal: false,
    columnWidth: "45%",
    endingShape: "rounded",
  },
}

// Options by category
const nodeChartOptions = {
  humidity: {
    title: "Humidity",
    form: "%",
    tools: basicTools,
    colors: ["#00bcf5"],
    fill: fillGradient,
    xaxis: basicXaxis,
    yaxis: {
      min: 0,
      max: 90,
    },
    stroke: areaStroke,
    tooltipX: tooltipXFormat,
  },
  temperature: {
    title: "Temperature",
    form: "°C",
    tools: basicTools,
    colors: ["#ff954e"],
    fill: fillGradient,
    xaxis: basicXaxis,
    yaxis: {
      min: -10,
      max: 60,
    },
    stroke: areaStroke,
    tooltipX: tooltipXFormat,
  },
  default: {
    title: "Default",
    form: "default",
    tools: basicTools,
    colors: ["#ffffff00"],
    fill: fillGradient,
    xaxis: basicXaxis,
    yaxis: {
      min: 0,
      max: 10,
    },
    stroke: areaStroke,
    tooltipX: tooltipXFormat,
  },
}

//Not in use yet/ const nodeChartHistoryOptions = {
//   historyActivityColumn: {
//     title: "Measurements",
//     form: "",
//     tools: historyTools,
//     colors: [activity],
//     fill: {
//       opacity: 1,
//     },
//     xaxis: basicXaxis,
//     yaxis: {},
//     stroke: columnStroke,
//     plotOptions: columnPlotOptions,
//     tooltipX: tooltipXFormatHistory,
//   },
//   historyActivityArea: {
//     title: "Measurements",
//     form: "",
//     tools: historyTools,
//     colors: [activity],
//     fill: {},
//     xaxis: basicXaxis,
//     yaxis: {},
//     stroke: areaStroke,
//     plotOptions: {},
//     tooltipX: tooltipXFormatHistory,
//   },
//   historyActivityLine: {
//     title: "Measurements",
//     form: "",
//     tools: historyTools,
//     colors: [activity],
//     fill: {},
//     xaxis: basicXaxis,
//     yaxis: {},
//     stroke: lineStroke,
//     plotOptions: {},
//     tooltipX: tooltipXFormatHistory,

//     dropShadow: {
//       enabled: !0,
//       color: "#000",
//       top: 18,
//       left: 7,
//       blur: 8,
//       opacity: 0.1,
//     },
//   },
// }

export { nodeChartOptions, basicGrid, barStroke }
